export default function Log(...args) {
    if (process.env.NODE_ENV === 'development') console.log(...args);
}